export default {
  'server.notFound': 'Not found',
  'server.networkError': 'Network error',
  'Server.AddBeat.Success': 'Adding success',
  'Server.DeleteBeat.Success': 'Deleting success',
  'Server.UpdateBeat.Success': 'Updating success',
  'Mes.Users.Add.Successfully': 'Add successful account',
  'Mes.Users.DeleteUsers.Successfully': 'Successfully erase',
  'Mes.Users.UpdateSuccessfully': 'successfulAccountInformationUpdates',
  'Mes.Researchs.Update.Successfully': 'Updating successful research',
  'Mes.Researchs.Add.Successfully': 'Add a successful study',
  'Mes.Researchs.Delete.Successfully': 'Delete successful research',
  'server.data.success': 'Successful',
  Successful: 'Successful',

  'Mes.User.SendPasswordRecoveryCodeSuccessfully': 'The recovery link has been sent to your email',
  'Mes.User.ResetPasswordSuccessfully': 'Successful password reset',
  'Mes.Profile.GetDetailSuccessfully': 'Get successful account information',
  'Mes.Profile.OldPassword.Wrong': 'The old password is not correct',
  'Mes.Profile.ChangePasswordSuccessfully': 'Successful password update',
  'Mes.Role.UpdateSuccessfully': 'Update the role of success',
  'Mes.Role.CreateSuccessfully': 'Add a successful role ',
  'Mes.Role.DeleteSuccessfully': 'Delete the role of success',
};
